import type React from 'react';
import type { ExpandedLayout } from '../../config/constants';

interface QuestionBubbleProps {
    content: string;
    questionId?: string;
    onRef?: (id: string, ref: HTMLElement | null) => void;
    viewLayout?: ExpandedLayout;
}

/**
 * QuestionBubble component - Chat-GPT-style question display
 * Renders question as a right-aligned bubble with light background
 * Background: 90% white + 10% primary color
 * Padding: 10px horizontal, 4px vertical
 * 32px spacing below bubble
 */
const QuestionBubble: React.FC<QuestionBubbleProps> = ({
    content,
    questionId,
    onRef,
    viewLayout = 'expanded',
}) => {
    const isCopilotLayout = viewLayout === 'copilot';
    const maxWidthClass = isCopilotLayout ? 'max-w-[70%]' : 'max-w-[50%] max-[852px]:max-w-[70%]';

    return (
        <div
            className="flex justify-end mb-8"
            ref={(el) => {
                if (questionId && onRef) {
                    onRef(questionId, el);
                }
            }}
        >
            <div
                className={`px-2.5 py-1 text-base wrap-break-word ${maxWidthClass}`}
                style={{
                    backgroundColor: 'var(--rw-bg-question-bubble)',
                    borderRadius: 'var(--rw-radius-card)',
                    color: 'var(--rw-text-primary)',
                }}
            >
                {content.charAt(0).toUpperCase() + content.slice(1)}
            </div>
        </div>
    );
};

export default QuestionBubble;
